import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from 'lib/ng2-sapmp/src/providers/utility.service';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb/breadcrumb.service';
import { ChipsService } from 'lib/ng2-sapmp/src/ui-components/chips/chips.service';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';

@Component({
  selector: 'app-abm-faciliate-enrollment',
  templateUrl: './abm-faciliate-enrollment.component.html',
  styleUrls: ['./abm-faciliate-enrollment.component.scss']
})

export class AbmFaciliateEnrollmentComponent implements OnInit {
  selectedbox: boolean;
  selectAccounts: any;
  userData: any;
  firstName: any;
  lastName: any;
  userEmail: any;
  faciliateData: any;


  constructor(private utilityService: UtilityService,
    private breadCrumbService: BreadCrumbService,
    private router: Router,
    private route: ActivatedRoute, 
    private chips: ChipsService,
    private pageloaderService: PageLoaderService
    ) { }

  ngOnInit() {
  this.pageloaderService.setPageLoaderStatus(true);
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.breadCrumbService.removeLastBreadCrumb();
    this.faciliateData = this.route.snapshot.data.pageData.abmfacilitatedenrollment;
    this.chips.setChips(this.faciliateData.chips);
    this.userData = JSON.parse(sessionStorage.getItem('user'));
    this.firstName = this.userData.user.firstName;
    this.lastName = this.userData.user.lastName;
    this.userEmail = this.userData.user.emailAddress;
  }

  checkConfirmation($event : any) {
    if ($event.target.checked) {
        this.selectedbox= true;
    }
    else {
        this.selectedbox= false;
    }
  }
}
